import Hero from '@components/sections/Hero'
import DiscoverStory from '@components/sections/DiscoverStory'
import ServicesOverview from '@components/sections/ServicesOverview'
import CTABanner from '@components/sections/CTABanner'
import NewFeatures from '@components/sections/NewFeatures'
import StatsCards from '@components/sections/StatsCards'
import ProjectGallery from '@components/sections/ProjectGallery'
import OurClients from '@components/sections/OurClients'
import DeliveringSolutions from '@components/sections/DeliveringSolutions'
import { JsonLd } from '../../components/seo/JsonLd'
import { localBusinessSchema, faqPageSchema } from '../../data/schemaData'
import heroVideo from '@assets/images/HomePageVideoBackground.mp4'
import heroImage from '@assets/images/HVACExperts_NiketEngg.jpg'
import discoverImage from '@assets/images/HVACExperts_NiketEngg.jpg'
import galleryImg1 from '@assets/images/HVACExperts_NiketEngg.jpg'
import galleryImg2 from '@assets/images/HVACExperts_NiketEnggv2.jpg'
import styles from './Home.module.css'

const galleryImages = [galleryImg1, galleryImg2]

const Home = () => {
  return (
    <div className={styles.home}>
      <JsonLd data={localBusinessSchema} />
      <JsonLd data={faqPageSchema} />
      <Hero
        title="We are your"
        highlightText="HVAC Experts"
        subtitle="Design | Installation | Maintenance"
        ctaText="Learn More"
        backgroundVideo={heroVideo}
        backgroundImage={heroImage}
      />
      <DiscoverStory image={discoverImage} />
      <ServicesOverview />
      <CTABanner />
      <NewFeatures />
      <StatsCards />
      <ProjectGallery images={galleryImages} />
      <OurClients />
      <DeliveringSolutions />
    </div>
  )
}

export default Home
